(function ($) {
  if (!$) return;

  function initSlick(selector, options) {
    if (typeof $.fn.slick !== 'function') return;

    var sliders = $(selector).not('.slick-initialized');
    if (sliders.length) sliders.slick(options);
  }

  initSlick('.home-testimonials-slider', {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    draggable: false,
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  initSlick('.homeCollectionsSlider', {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    draggable: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 690,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          draggable: true,
        },
      },
    ],
  });

  initSlick('.heroCat', {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 690,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true,
        },
      },
    ],
  });

  initSlick('.home-best-collections .grid', {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    draggable: false,
    responsive: [
      {
        breakpoint: 690,
        settings: {
          draggable: true,
        },
      },
    ],
  });

  var tabs = $('#tabs-nav li');
  if (tabs.length) {
    tabs.on('click', function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.tab-content').hide();
        return false;
      }

      tabs.removeClass('active');
      $(this).addClass('active');
      $('.tab-content').hide();
      var activeTab = $(this).find('a').attr('href');
      if (activeTab) $(activeTab).slideToggle();
      return false;
    });
  }

  // One delegated listener and native smooth scrolling replace a separate
  // jQuery animation handler on every hash link.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link || link.hasAttribute('data-disabled-scroll')) return;

    var href = link.getAttribute('href');
    if (!href || href === '#') return;

    var id = href.slice(1);
    try {
      id = decodeURIComponent(id);
    } catch (error) {
      return;
    }

    var target = document.getElementById(id);
    if (!target) return;

    event.preventDefault();
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY,
      behavior: 'smooth',
    });
  });

  var firstGridTab = $('.grid__item.right_grid__item .tabs li:first-child');
  if (firstGridTab.length) firstGridTab.trigger('click');

  $('.productsTabContent #tabs-nav li:first-child').addClass('active');
  $('.productsTabContent #tabs-content #tab1').show();

  var safeSource = $('.template-product #shopify-section-text-columns');
  var safeTarget = $('.homePageSafe');
  if (safeSource.length && safeTarget.length) {
    safeTarget.html(safeSource.html());
  }
})(window.jQuery);
